import { DominantLeague } from "../types/faction"
import { PointHistory, PointHistoryEvent } from "../types/location"

function pickString(value: unknown, fallback = ""): string {
  if (typeof value === "string") return value.trim() || fallback
  if (value == null) return fallback
  return String(value).trim() || fallback
}

function normalizeDominantLeague(value: unknown): DominantLeague | null | undefined {
  const raw = pickString(value).toUpperCase()
  if (raw === "TITAN" || raw === "ATLANT") return raw
  if (raw === "NEUTRAL") return "NEUTRAL"
  return undefined
}

function normalizePointHistoryEvent(raw: unknown): PointHistoryEvent | null {
  if (!raw || typeof raw !== "object" || Array.isArray(raw)) return null
  const obj = raw as Record<string, unknown>
  const text = pickString(obj.text)
  if (!text) return null

  const kind = pickString(obj.kind ?? obj.type, "UNKNOWN")
  const occurredAtRaw = obj.occurredAt ?? obj.occurred_at
  const nicknameRaw = obj.nickname ?? obj.userNickname ?? obj.user_nickname

  return {
    kind,
    text,
    league: normalizeDominantLeague(obj.league),
    occurredAt:
      occurredAtRaw == null ? undefined : pickString(occurredAtRaw) || undefined,
    nickname: nicknameRaw == null ? undefined : pickString(nicknameRaw) || undefined,
  }
}

export function normalizePointHistory(data: unknown): PointHistory {
  const root =
    data && typeof data === "object" && !Array.isArray(data)
      ? (data as Record<string, unknown>)
      : {}
  const nested = root.data ?? root.result ?? root.payload
  const source =
    nested && typeof nested === "object" && !Array.isArray(nested)
      ? (nested as Record<string, unknown>)
      : root

  const historyRaw = source.history ?? source.pointHistory ?? source.point_history
  const historyObj =
    historyRaw && typeof historyRaw === "object" && !Array.isArray(historyRaw)
      ? (historyRaw as Record<string, unknown>)
      : source

  const eventsRaw = Array.isArray(historyObj.events)
    ? historyObj.events
    : Array.isArray(source.events)
      ? source.events
      : Array.isArray(data)
        ? data
        : []

  const events = eventsRaw
    .map(normalizePointHistoryEvent)
    .filter((event): event is PointHistoryEvent => event != null)

  return { events }
}
